import { MessageV2DTO } from 'support/types';
import { AlertSection } from 'components/Display/Alert';
import { Alert } from 'components/Display/Alert/Alert';

import { useProcurosErrorCodeCopy } from '../hooks/useProcurosErrorCodeCopy';

type Props = {
  blockingError: MessageV2DTO['blocking_error'] | undefined;
};

export const ProcurosResolverGenericBlockingPreset = ({ blockingError }: Props) => {
  const { title, description, howToFix } = useProcurosErrorCodeCopy(blockingError);

  return (
    <Alert withoutIcon severity="neutral" fullWidth className="max-h-72 overflow-y-auto">
      <AlertSection severity="neutral" title={title}>
        {description}
        {description && howToFix ? <br /> : null}
        {howToFix}
      </AlertSection>
    </Alert>
  );
};
